











export default
  props:
    title:
      type: String
      default: ''
    messages:
      type: Array
      default: []
    picture:
      type: String
      default: ''
    character:
      type: String
      default: ''
    mode:
      type: Number
      default: 0
